export default __webpack_public_path__ + "static/spitz-mobile-screens-mobile-2669aced2413812b59d407fc8d08c526.jpg";